import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './App.css';
import About from './Components/About/About';
import Home from './Components/Home/Home';
import Footer from './Components/Footer/Footer';
import Training from './Components/Training/Training';
import Survey from './Components/Services/Survey/Survey';
import Gis from './Components/Services/Gis/Gis';
import Soil from './Components/Services/Soil/Soil';
import Arch from './Components/Services/Arch/Arch';
import Electrical from './Components/Services/Electrical/Electrical';
import Plumbing from './Components/Services/Plumbing/Plumbing';
import Construction from './Components/Services/Costruction/Construction';
import Clients from './Components/Clients/Clients';


function App() {
  return (
    <div className="App">
        <BrowserRouter>
          <Switch>
            <Route exact path="/">
              <Home></Home>
            </Route>
            <Route path="/home">
              <Home></Home>
            </Route>
            <Route path="/about">
              <About></About>
            </Route>
            <Route path="/survey">
              <Survey></Survey>
            </Route>
            <Route path="/gis">
              <Gis></Gis>
            </Route>
            <Route path="/training">
              <Training></Training>
            </Route>
            <Route path="/soil">
              <Soil></Soil>
            </Route>
            <Route path="/arch">
              <Arch></Arch>
            </Route>
            <Route path="/elec">
              <Electrical></Electrical>
            </Route>
            <Route path="/plumbing">
              <Plumbing></Plumbing>
            </Route>
            <Route path="/construction">
              <Construction></Construction>
            </Route>
            <Route path="/clients">
              <Clients></Clients>
            </Route>
          </Switch>
          <Footer></Footer>
        </BrowserRouter>
    </div>
  );
}

export default App;
